export default [
  {
    icon: 'home',
    title: 'Home',
    to: '/',
    auth: true
  },
  {
    icon: 'book',
    title: 'Departamentos',
    to: '/departamentos',
    auth: true
  },
  {
    icon: 'people',
    title: 'Fornecedores',
    to: '/Fornecedores',
    auth: true
  },
  {
    icon: 'request_quote',
    title: 'Requisições',
    to: '/requisicoes',
    auth: true
  },
  {
    icon: 'book',
    title: 'Requisições Cliente',
    to: '/requisicoescliente',
    auth: true
  },
  {
    icon: 'request_page',
    title: 'Requisições Baixa',
    to: '/requisicoesbaixa',
    auth: true
  },
  {
    icon: 'book',
    title: 'Plano',
    to: '/plano',
    auth: true
  },
  {
    icon: 'drive_eta',
    title: 'Veículos',
    to: '/veiculo',
    auth: true
  },
  {
    icon: 'people',
    title: 'Usuários Profissionais',
    to: '/usuariosprofissionais',
    auth: true
  },
  {
    icon: 'book',
    title: 'Usuários Fornecedores',
    to: '/usuariosfornecedores',
    auth: true
  },
  {
    icon: 'people',
    title: 'Profissionais Veículos',
    to: '/profissionaisveiculos',
    auth: true
  },
  {
    icon: 'people',
    title: 'Habilitar Fornecedores',
    to: '/empresafornecedores',
    auth: true
  },
  {
    icon: 'book',
    title: 'Fornecedor',
    to: '/fornecedor',
    auth: true
  },
  {
    icon: 'notes',
    title: 'Relatórios',
    to: '/relatorios',
    auth: true
  },
  {
    icon: 'lock',
    title: 'Login',
    to: '/login',
    auth: false
  },
  {
    icon: 'view_list',
    title: 'Cadastros',
    children: [
      {
        title: 'Usuários',
        to: '/usuarios',
        auth: true
      },
      {
        title: 'Profissionais',
        to: '/profissionais',
        auth: true
      },
      {
        title: 'Permissões a Usuários',
        to: '/permissoes',
        auth: true
      }
    ]
  },
  {
    icon: 'lock_open',
    title: 'Sair',
    to: '/logout',
    auth: true
  }]
